import { TFunction } from 'i18next'
import { z } from 'zod'

export const createFaqSchema = (t: TFunction) =>
  z.object({
    question: z.string().min(1, {
      message: t('required'),
    }),
    answer: z.string().min(1, {
      message: t('required'),
    }),
  })
